import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';

/* Glass card that tilts toward the cursor with a soft spring + glow follow. */
const TiltCard = ({ children, className = '', max = 8, ...rest }) => {
  const ref = useRef(null);
  const px = useMotionValue(0.5);
  const py = useMotionValue(0.5);

  const sx = useSpring(px, { stiffness: 180, damping: 18 });
  const sy = useSpring(py, { stiffness: 180, damping: 18 });

  const rotateX = useTransform(sy, [0, 1], [max, -max]);
  const rotateY = useTransform(sx, [0, 1], [-max, max]);
  const glowX = useTransform(sx, [0, 1], ['0%', '100%']);
  const glowY = useTransform(sy, [0, 1], ['0%', '100%']);

  const handleMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    px.set((e.clientX - r.left) / r.width);
    py.set((e.clientY - r.top) / r.height);
  };
  const reset = () => { px.set(0.5); py.set(0.5); };

  return (
    <motion.div
      ref={ref}
      className={`tilt-card glass ${className}`}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      style={{ rotateX, rotateY, transformPerspective: 900 }}
      {...rest}
    >
      <motion.span
        className="tilt-glow"
        aria-hidden="true"
        style={{
          background: useTransform(
            [glowX, glowY],
            ([x, y]) => `radial-gradient(220px circle at ${x} ${y}, rgba(43,255,136,0.16), transparent 70%)`
          ),
        }}
      />
      <div className="tilt-inner">{children}</div>
    </motion.div>
  );
};

export default TiltCard;
